var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgStopwatch = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4998 18.0502C14.4763 18.0502 17.6998 14.8266 17.6998 10.8502C17.6998 6.87374 14.4763 3.6502 10.4998 3.6502C6.52335 3.6502 3.2998 6.87374 3.2998 10.8502C3.2998 14.8266 6.52335 18.0502 10.4998 18.0502ZM10.4998 7.05019C10.8312 7.05019 11.0998 7.31882 11.0998 7.6502V10.8502C11.0998 11.1816 10.8312 11.4502 10.4998 11.4502C10.1684 11.4502 9.8998 11.1816 9.8998 10.8502V7.6502C9.8998 7.31882 10.1684 7.05019 10.4998 7.05019Z",
    fill: "url(#paint0_linear_8563_28227)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.2998 2.0502C8.2998 1.71882 8.56843 1.4502 8.8998 1.4502H12.0998C12.4312 1.4502 12.6998 1.71882 12.6998 2.0502C12.6998 2.38157 12.4312 2.6502 12.0998 2.6502H8.8998C8.56843 2.6502 8.2998 2.38157 8.2998 2.0502Z",
    fill: "url(#paint1_linear_8563_28227)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8563_28227",
    x1: 3.2998,
    y1: 1.4502,
    x2: 19.7334,
    y2: 15.7059,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD362"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#F6932B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F16601"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_8563_28227",
    x1: 3.2998,
    y1: 1.4502,
    x2: 19.7334,
    y2: 15.7059,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD362"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#F6932B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F16601"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgStopwatch, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Stopwatch.f3cb4f62.svg";
export { ForwardRef as ReactComponent };